// extracted by mini-css-extract-plugin
module.exports = {"label":"PerformanceComponent_label__1iIDj","maxHeight15Em":"PerformanceComponent_maxHeight15Em__1FNKJ"};